import { render, staticRenderFns } from "./OverseasEventCard.vue?vue&type=template&id=714287c1&scoped=true"
import script from "./OverseasEventCard.vue?vue&type=script&lang=js"
export * from "./OverseasEventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714287c1",
  null
  
)

export default component.exports